import { useEffect, useState, useRef } from "react";
import {
  useToast,
  Box,
  Text,
  Grid,
  GridItem,
  Heading,
  Button,
  Flex,
  Image,
  Badge,
  Select,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Divider,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  Progress,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  VStack,
  Spinner,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  useOutsideClick,
  Switch
} from "@chakra-ui/react";
import { SearchIcon as ChakraSearchIcon } from "@chakra-ui/icons";
import { jwtDecode } from "jwt-decode"; // Importando jwtDecode para verificar nível de usuário
import { UserSearchSelect } from "./common/SearchSelects";

// Componentes de ícones customizados usando o componente Icon do Chakra
const CustomIcon = ({ children }) => (
  <Icon viewBox="0 0 24 24" mr={2}>
    {children}
  </Icon>
);

// Ícones como componentes funcionais simples
const CarIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z" />
  </CustomIcon>
);

const FilterIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3H19C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z" />
  </CustomIcon>
);

const SearchIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
  </CustomIcon>
);

const CameraIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
  </CustomIcon>
);

const RefreshIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z" />
  </CustomIcon>
);

// Formatador de data simples
const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR') + ' - ' + 
           date.toLocaleTimeString('pt-BR');
  } catch (error) {
    return dateString;
  }
};

const VehiclePassages = () => {
  const [passages, setPassages] = useState([]);
  const [filteredPassages, setFilteredPassages] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false); // Novo estado para carregar mais
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [statistics, setStatistics] = useState({
    totalLast24Hours: 0,
    totalLast7Days: 0,
    totalLast30Days: 0,
    alertsLast24Hours: 0,
    avgConfidence: 0,
    topCameras: [],
    topPlates: [],
    hourlyDistribution: []
  });
  const [loadingStats, setLoadingStats] = useState(true);
  
  // Novo estado para paginação
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    hasMore: true,
    activeFilter: 'none' // 'none', 'date', 'plate', 'camera', 'recent'
  });
  
  // Format dates for a week ago and today
  const getOneWeekAgo = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
  };
  
  const getToday = () => {
    return new Date().toISOString().split('T')[0]; // Returns YYYY-MM-DD
  };
  
  // Atualizar o estado de filtros para incluir plateContains
  const [filters, setFilters] = useState({
    plate: "",
    plateContains: false, // Novo campo
    cameraId: "",
    startDate: "",
    endDate: "",
    startTime: "", // Novo campo para hora inicial
    endTime: "", // Novo campo para hora final
  });
  
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  // Adicionar novos estados para gerenciamento de placas monitoradas
  const [monitoredPlates, setMonitoredPlates] = useState([]);
  const [plateFormData, setPlateFormData] = useState({
    plateNumber: '',
    description: '',
    vehicleType: '',
    isBlacklist: false,
    alertPriority: 'medium',
    notificationEnabled: true,
    notes: '',
    interestedUserIds: []
  });
  const [selectedPlate, setSelectedPlate] = useState(null);
  const [platePassages, setPlatePassages] = useState([]);
  const [loadingPlates, setLoadingPlates] = useState(false);
  const [loadingPlatePassages, setLoadingPlatePassages] = useState(false);
  
  // Adicionar estado para armazenar o nível do usuário
  const [userLevel, setUserLevel] = useState(1);
  
  // Utilizaremos para o modal de adicionar placa
  const { 
    isOpen: isPlateModalOpen, 
    onOpen: onPlateModalOpen, 
    onClose: onPlateModalClose 
  } = useDisclosure();
  
  // Modal de edição de placa
  const { 
    isOpen: isEditPlateModalOpen, 
    onOpen: onEditPlateModalOpen, 
    onClose: onEditPlateModalClose 
  } = useDisclosure();
  
  const [editingPlate, setEditingPlate] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedInterestedToAdd, setSelectedInterestedToAdd] = useState('');
  const [selectedInterestedToEdit, setSelectedInterestedToEdit] = useState('');

  useEffect(() => {
    // Verificar o nível do usuário ao iniciar
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserLevel(decoded.role);
      } catch (error) {
        console.error('Erro ao decodificar token:', error);
      }
    }
    
    fetchPassages();
    fetchCameras();
    fetchStatistics();
  }, []);

  // Buscar usuários (usado para selecionar interessado) — carregado para admins/gestores
  useEffect(() => {
    if (userLevel >= 3) fetchUsers();
  }, [userLevel]);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/users', { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Erro ao buscar usuários');
      const data = await res.json();
      setUsers(data || []);
    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
    }
  };

  useEffect(() => {
    applyFilters();
  }, [passages, filters]);

  // Adicionar efeito para carregar placas monitoradas ao iniciar apenas para usuários nível 3+
  useEffect(() => {
    if (userLevel >= 3) {
      fetchMonitoredPlates();
    }
  }, [userLevel]);

  // Nova função para buscar estatísticas
  const fetchStatistics = async () => {
    setLoadingStats(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/passages/statistics', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar estatísticas');
      
      const data = await response.json();
      setStatistics(data);
    } catch (error) {
      toast({
        title: "Erro ao buscar estatísticas",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingStats(false);
    }
  };

  // Modificar fetchPassages para suportar paginação
  const fetchPassages = async (loadMore = false) => {
    const isInitialLoad = !loadMore;
    
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const token = localStorage.getItem('token');
      const page = loadMore ? pagination.page + 1 : 1;
      const { limit } = pagination;
      
      const response = await fetch(`/api/passages?page=${page}&limit=${limit}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e informações de paginação
      const passagesData = responseData.passages || responseData;
      const hasMore = page < responseData.totalPages;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualiza os estados adequadamente
      if (loadMore) {
        setPassages(prev => [...prev, ...passagesWithImages]);
        setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      } else {
        setPassages(passagesWithImages);
        setFilteredPassages(passagesWithImages);
      }
      
      // Atualiza a paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'none'
      }));
      
    } catch (error) {
      console.error('Erro ao processar passagens:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Nova função para buscar passagens das últimas 24 horas
  const fetchLast24Hours = async (loadMore = false) => {
    const isInitialLoad = !loadMore;
    
    if (isInitialLoad) {
      setLoading(true);
      // Reset pagination when calling with a new filter
      setPagination(prev => ({
        ...prev,
        page: 1,
        hasMore: true
      }));
    } else {
      setLoadingMore(true);
    }
    
    try {
      const token = localStorage.getItem('token');
      const page = loadMore ? pagination.page + 1 : 1;
      const { limit } = pagination;
      
      const response = await fetch(`/api/passages/last-24-hours?page=${page}&limit=${limit}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens recentes');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e informações de paginação
      const passagesData = responseData.passages || responseData;
      const hasMore = responseData.totalPages ? page < responseData.totalPages : false;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualiza os estados adequadamente - aqui é a principal mudança
      // Para carregamento inicial sempre substituímos os dados em vez de acumular
      if (loadMore) {
        setPassages(prev => [...prev, ...passagesWithImages]);
        setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      } else {
        setPassages(passagesWithImages);
        setFilteredPassages(passagesWithImages);
      }
      
      // Atualiza a paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'recent'
      }));
      
      if (!loadMore) {
        toast({
          title: "Passagens das últimas 24 horas carregadas",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Erro ao processar passagens recentes:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Corrigir o método fetchImageWithAuth para usar o mesmo padrão de outros blobs
  const fetchImageWithAuth = async (imagePath) => {
    try {
      if (!imagePath) return '';
      
      // Extrai o nome do arquivo do caminho
      const fileName = imagePath.split('\\').pop().split('/').pop();
      
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/passages/image/${fileName}`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });

      if (!response.ok) throw new Error('Erro ao buscar imagem');
      
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Erro ao carregar imagem:', error);
      return '';
    }
  };

  const fetchCameras = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/cameras', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar câmeras');
      
      const data = await response.json();
      setCameras(data);
    } catch (error) {
      toast({
        title: "Erro ao buscar câmeras",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Modificar fetchPassagesByDateRange para suportar paginação
  const fetchPassagesByDateRange = async (loadMore = false) => {
    const isInitialLoad = !loadMore;
    
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const token = localStorage.getItem('token');
      const { startDate, endDate } = filters;
      const page = loadMore ? pagination.page + 1 : 1;
      const { limit } = pagination;
      
      const response = await fetch(`/api/passages/date-range?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens por data');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e informações de paginação
      const passagesData = responseData.passages || responseData;
      const hasMore = responseData.totalPages ? page < responseData.totalPages : false;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualiza os estados adequadamente
      if (loadMore) {
        setPassages(prev => [...prev, ...passagesWithImages]);
        setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      } else {
        setPassages(passagesWithImages);
        setFilteredPassages(passagesWithImages);
      }
      
      // Atualiza a paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'date'
      }));
      
      if (!loadMore) {
        toast({
          title: "Filtro aplicado com sucesso",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Erro ao processar passagens por data:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Modificar fetchPassagesByPlate para suportar paginação
  const fetchPassagesByPlate = async (loadMore = false) => {
    if (!filters.plate) return;
    
    const isInitialLoad = !loadMore;
    
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const token = localStorage.getItem('token');
      const page = loadMore ? pagination.page + 1 : 1;
      const { limit } = pagination;
      
      // Adicionar parâmetro contains baseado no estado do switch
      const containsParam = filters.plateContains ? '&contains=true' : '';
      
      const response = await fetch(`/api/passages/plate/${filters.plate}?page=${page}&limit=${limit}${containsParam}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens por placa');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e informações de paginação
      const passagesData = responseData.passages || responseData;
      const hasMore = responseData.totalPages ? page < responseData.totalPages : false;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualiza os estados adequadamente
      if (loadMore) {
        setPassages(prev => [...prev, ...passagesWithImages]);
        setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      } else {
        setPassages(passagesWithImages);
        setFilteredPassages(passagesWithImages);
      }
      
      // Atualiza a paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'plate'
      }));
      
      if (!loadMore) {
        toast({
          title: "Filtro por placa aplicado",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Erro ao processar passagens por placa:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Modificar fetchPassagesByCamera para suportar paginação
  const fetchPassagesByCamera = async (loadMore = false) => {
    if (!filters.cameraId) return;
    
    const isInitialLoad = !loadMore;
    
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const token = localStorage.getItem('token');
      // Garantir que estamos enviando o ID da câmera como número
      const cameraId = parseInt(filters.cameraId, 10);
      const page = loadMore ? pagination.page + 1 : 1;
      const { limit } = pagination;
      
      console.log('Buscando passagens para câmera ID:', cameraId, 'página:', page);
      
      const response = await fetch(`/api/passages/camera/${cameraId}?page=${page}&limit=${limit}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens por câmera');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e informações de paginação
      const passagesData = responseData.passages || responseData;
      const hasMore = responseData.totalPages ? page < responseData.totalPages : false;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      console.log(`Recebidas ${passagesData.length} passagens para a câmera ${cameraId}, página ${page}`);
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualiza os estados adequadamente
      if (loadMore) {
        setPassages(prev => [...prev, ...passagesWithImages]);
        setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      } else {
        setPassages(passagesWithImages);
        setFilteredPassages(passagesWithImages);
      }
      
      // Atualiza a paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'camera'
      }));
      
      if (!loadMore) {
        toast({
          title: `${passagesWithImages.length} passagens encontradas`,
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Erro ao processar passagens por câmera:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Função para carregar mais passagens com base no filtro ativo
  const loadMorePassages = () => {
    switch (pagination.activeFilter) {
      case 'none':
        fetchPassages(true);
        break;
      case 'recent':
        fetchLast24Hours(true);
        break;
      case 'date':
        fetchPassagesByDateRange(true);
        break;
      case 'plate':
        fetchPassagesByPlate(true);
        break;
      case 'camera':
        fetchPassagesByCamera(true);
        break;
      case 'advanced':
        loadMoreAdvancedSearch();
        break;
      default:
        fetchPassages(true);
    }
  };

  const refreshPassages = async () => {
    setLoading(true);
    
    try {
      // Reset pagination
      setPagination(prev => ({
        ...prev,
        page: 1,
        hasMore: true
      }));
      
      // Call the appropriate fetch function based on current filter
      switch (pagination.activeFilter) {
        case 'recent':
          await fetchLast24Hours(false);
          break;
        case 'date':
          await fetchPassagesByDateRange(false);
          break;
        case 'plate':
          await fetchPassagesByPlate(false);
          break;
        case 'camera':
          await fetchPassagesByCamera(false);
          break;
        default:
          await fetchPassages(false);
          break;
      }
      
      toast({
        title: "Passagens atualizadas",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao atualizar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    let result = [...passages];
    
    // Filtragem adicional no cliente (quando necessário)
    if (filters.plate) {
      result = result.filter(passage => 
        passage.plateNumber.toUpperCase().includes(filters.plate.toUpperCase())
      );
    }
    
    if (filters.cameraId) {
      // Converter filters.cameraId para número para comparação consistente
      const cameraIdNum = parseInt(filters.cameraId, 10);
      result = result.filter(passage => passage.cameraId === cameraIdNum);
      
      console.log('Filtrando por câmera:', {
        cameraId: cameraIdNum,
        passagensFiltradas: result.length,
        totalPassagens: passages.length
      });
    }
    
    setFilteredPassages(result);
  };

  // Atualizar resetFilters para incluir o novo campo
  const resetFilters = () => {
    setFilters({
      plate: "",
      plateContains: false, // Incluir no reset
      cameraId: "",
      startDate: "",
      endDate: "",
      startTime: "", // Incluir no reset
      endTime: "", // Incluir no reset
    });
    
    setPagination(prev => ({
      ...prev,
      page: 1,
      hasMore: true,
      activeFilter: 'none'
    }));
    
    fetchPassages();
  };

  const getCameraName = (cameraId) => {
    if (!cameraId) return 'Câmera desconhecida';
    
    // Assegurar que comparamos números com números
    const cameraIdNum = typeof cameraId === 'string' ? parseInt(cameraId, 10) : cameraId;
    const camera = cameras.find(cam => cam.id === cameraIdNum);
    return camera ? camera.name : `Câmera ID: ${cameraId}`;
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  // Componente para exibir a distribuição por hora do dia
  const HourlyDistribution = ({ data }) => {
    // Preencher com zeros as horas sem dados
    const hourlyData = Array(24).fill(0);
    data.forEach(item => {
      hourlyData[parseInt(item.hour)] = parseInt(item.count);
    });

    const maxCount = Math.max(...hourlyData);

    return (
      <Box mt={4}>
        <Heading size="sm" mb={2}>Distribuição de Passagens por Hora</Heading>
        <SimpleGrid columns={6} spacing={2}>
          {hourlyData.map((count, hour) => (
            <Box key={hour}>
              <Text fontSize="xs" textAlign="center">{hour}h</Text>
              <Progress 
                value={(count / maxCount) * 100} 
                colorScheme="blue" 
                height="20px" 
                borderRadius="md"
              />
              <Text fontSize="xs" textAlign="center">{count}</Text>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    );
  };

  // Função para determinar a cor do badge de alerta
  const getAlertBadgeColor = (passage) => {
    if (!passage.isAlert) return null;
    
    // Verificar se temos a informação de blacklist na descrição do alerta
    if (passage.alertDescription && passage.alertDescription.includes('BLACKLISTED_PLATE')) {
      return "red";
    }
    
    // Padrão para placas monitoradas normais
    return "orange";
  };

  // Função para determinar o texto do badge de alerta
  const getAlertBadgeText = (passage) => {
    if (!passage.isAlert) return null;
    
    // Verificar se temos a informação de blacklist na descrição do alerta
    if (passage.alertDescription && passage.alertDescription.includes('BLACKLISTED_PLATE')) {
      return "PLACA NA BLACKLIST";
    }
    
    // Padrão para placas monitoradas normais
    return "PLACA MONITORADA";
  };

  // Função para buscar placas monitoradas
  const fetchMonitoredPlates = async () => {
    setLoadingPlates(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/monitored-plates', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar placas monitoradas');
      
      const data = await response.json();
      setMonitoredPlates(data);
    } catch (error) {
      toast({
        title: "Erro ao buscar placas monitoradas",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingPlates(false);
    }
  };
  
  // Função para buscar passagens de uma placa específica
  const fetchPlatePassages = async (plateNumber) => {
    setLoadingPlatePassages(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/passages/plate/${plateNumber}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens da placa');
      
      const responseData = await response.json();
      
      // Extrai o array de passages e processa as imagens
      const passagesData = responseData.passages || responseData;
      
      if (!Array.isArray(passagesData)) {
        throw new Error('Formato de dados inválido: esperava um array de passagens');
      }
      
      // Processa as imagens antes de armazenar no estado
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      setPlatePassages(passagesWithImages);
    } catch (error) {
      toast({
        title: "Erro ao buscar passagens da placa",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingPlatePassages(false);
    }
  };
  
  // Função para adicionar uma nova placa monitorada
  const handleAddPlate = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/monitored-plates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...plateFormData,
          interestedUserIds: plateFormData.interestedUserIds || []
        })
      });
      
      if (!response.ok) throw new Error('Erro ao adicionar placa');
      
      const newPlate = await response.json();
      
      // Atualiza a lista de placas
      setMonitoredPlates(prev => [...prev, newPlate]);
      
      // Limpa o formulário
      setPlateFormData({
        plateNumber: '',
        description: '',
        vehicleType: '',
        isBlacklist: false,
        alertPriority: 'medium',
        notificationEnabled: true,
        notes: '',
        interestedUserIds: []
      });
      setSelectedInterestedToAdd('');
      
      // Fecha o modal
      onPlateModalClose();
      
      toast({
        title: "Placa adicionada com sucesso",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao adicionar placa",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  // Função para remover uma placa monitorada
  const handleRemovePlate = async (plateId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/monitored-plates/${plateId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) throw new Error('Erro ao remover placa');
      
      // Remove a placa da lista
      setMonitoredPlates(prev => prev.filter(plate => plate.id !== plateId));
      
      // Se a placa selecionada foi removida, limpa a seleção
      if (selectedPlate && selectedPlate.id === plateId) {
        setSelectedPlate(null);
        setPlatePassages([]);
      }
      
      toast({
        title: "Placa removida com sucesso",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao remover placa",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  // Função para alternar o status de blacklist
  const handleToggleBlacklist = async (plate) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/monitored-plates/${plate.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...plate,
          isBlacklist: !plate.isBlacklist
        })
      });
      
      if (!response.ok) throw new Error('Erro ao atualizar status da placa');
      
      const updatedPlate = await response.json();
      
      // Atualiza a placa na lista
      setMonitoredPlates(prev => 
        prev.map(p => p.id === plate.id ? updatedPlate : p)
      );
      
      // Se a placa selecionada foi atualizada, atualiza a seleção
      if (selectedPlate && selectedPlate.id === plate.id) {
        setSelectedPlate(updatedPlate);
      }
      
      toast({
        title: plate.isBlacklist 
          ? "Placa removida da blacklist" 
          : "Placa adicionada à blacklist",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao atualizar status da placa",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  // Função para abrir modal de edição
  const handleOpenEditPlate = (plate) => {
    setEditingPlate({
      ...plate
    });
    onEditPlateModalOpen();
  };
  
  // Função para salvar edição de placa
  const handleUpdatePlate = async () => {
    try {
      if (!editingPlate) return;
      
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/monitored-plates/${editingPlate.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...editingPlate,
          interestedUserIds: editingPlate.interestedUserIds || []
        })
      });
      
      if (!response.ok) throw new Error('Erro ao atualizar placa');
      
      const updatedPlate = await response.json();
      
      // Atualiza a placa na lista
      setMonitoredPlates(prev => 
        prev.map(p => p.id === editingPlate.id ? updatedPlate : p)
      );
      
      // Se a placa selecionada foi atualizada, atualiza a seleção
      if (selectedPlate && selectedPlate.id === editingPlate.id) {
        setSelectedPlate(updatedPlate);
      }
      
      toast({
        title: "Placa atualizada com sucesso",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      
      onEditPlateModalClose();
      setEditingPlate(null);
      setSelectedInterestedToEdit('');
    } catch (error) {
      toast({
        title: "Erro ao atualizar placa",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  // Função para selecionar uma placa e mostrar suas passagens
  const handleSelectPlate = (plate) => {
    setSelectedPlate(plate);
    fetchPlatePassages(plate.plateNumber);
  };

  // Função para atualizar o formulário de placa
  const handlePlateFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPlateFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const applyAdvancedFilters = async () => {
    setLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      let queryParams = new URLSearchParams();
      
      // Incluir todos os parâmetros, incluindo plateContains
      if (filters.plate) queryParams.append('plateNumber', filters.plate);
      if (filters.plateContains) queryParams.append('plateContains', 'true');
      if (filters.cameraId) queryParams.append('cameraId', filters.cameraId);
      
      // Mesclar data e hora se fornecidas
      if (filters.startDate) {
        let time = '00:00:00';
        if (filters.startTime && filters.startTime.trim() !== '') {
          // Input type="time" retorna HH:MM, precisamos adicionar :SS
          time = filters.startTime.includes(':') && filters.startTime.split(':').length === 2 
            ? `${filters.startTime}:00` 
            : filters.startTime;
        }
        queryParams.append('startDate', `${filters.startDate} ${time}`);
      }
      if (filters.endDate) {
        let time = '23:59:59.999';
        if (filters.endTime && filters.endTime.trim() !== '') {
          // Input type="time" retorna HH:MM, precisamos adicionar :SS
          time = filters.endTime.includes(':') && filters.endTime.split(':').length === 2 
            ? `${filters.endTime}:59.999` 
            : filters.endTime;
        }
        queryParams.append('endDate', `${filters.endDate} ${time}`);
      }
      
      // Adicionar paginação
      queryParams.append('page', 1);
      queryParams.append('limit', pagination.limit);
      
      const url = `/api/passages/search?${queryParams.toString()}`;
      console.log('URL de pesquisa avançada:', url);
      
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar passagens com filtros');
      
      const responseData = await response.json();
      
      // Processar os resultados
      const passagesData = responseData.passages || [];
      const hasMore = responseData.totalPages ? 1 < responseData.totalPages : false;
      
      // Processar imagens
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualizar estados
      setPassages(passagesWithImages);
      setFilteredPassages(passagesWithImages);
      
      // Atualizar paginação
      setPagination(prev => ({
        ...prev,
        page: 1,
        hasMore,
        activeFilter: 'advanced'
      }));
      
      // Exibir mensagem de sucesso
      if (passagesWithImages.length > 0) {
        toast({
          title: `${passagesWithImages.length} passagens encontradas`,
          description: responseData.dateRange?.searchPeriod || 'Filtros aplicados com sucesso',
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Nenhuma passagem encontrada",
          description: "Tente modificar os critérios de busca",
          status: "info",
          duration: 3000,
          isClosable: true,
        });
      }
      
    } catch (error) {
      console.error('Erro ao aplicar filtros avançados:', error);
      toast({
        title: "Erro ao buscar passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const loadMoreAdvancedSearch = async () => {
    setLoadingMore(true);
    
    try {
      const token = localStorage.getItem('token');
      const page = pagination.page + 1;
      const { limit } = pagination;
      
      let queryParams = new URLSearchParams();
      
      // Adicionar todos os filtros ativos, incluindo plateContains
      if (filters.plate) queryParams.append('plateNumber', filters.plate);
      if (filters.plateContains) queryParams.append('plateContains', 'true');
      if (filters.cameraId) queryParams.append('cameraId', filters.cameraId);
      
      // Mesclar data e hora se fornecidas (mesma lógica do applyAdvancedFilters)
      if (filters.startDate) {
        let time = '00:00:00';
        if (filters.startTime && filters.startTime.trim() !== '') {
          // Input type="time" retorna HH:MM, precisamos adicionar :SS
          time = filters.startTime.includes(':') && filters.startTime.split(':').length === 2 
            ? `${filters.startTime}:00` 
            : filters.startTime;
        }
        queryParams.append('startDate', `${filters.startDate} ${time}`);
      }
      if (filters.endDate) {
        let time = '23:59:59.999';
        if (filters.endTime && filters.endTime.trim() !== '') {
          // Input type="time" retorna HH:MM, precisamos adicionar :SS
          time = filters.endTime.includes(':') && filters.endTime.split(':').length === 2 
            ? `${filters.endTime}:59.999` 
            : filters.endTime;
        }
        queryParams.append('endDate', `${filters.endDate} ${time}`);
      }
      
      // Adicionar paginação
      queryParams.append('page', page);
      queryParams.append('limit', limit);
      
      const url = `/api/passages/search?${queryParams.toString()}`;
      console.log('Carregando mais resultados de busca avançada:', url);
      
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar mais passagens');
      
      const responseData = await response.json();
      
      // Processar os resultados
      const passagesData = responseData.passages || [];
      const hasMore = responseData.totalPages ? page < responseData.totalPages : false;
      
      // Processar imagens
      const passagesWithImages = await Promise.all(passagesData.map(async (passage) => {
        if (passage.imagePath) {
          const imageUrl = await fetchImageWithAuth(passage.imagePath);
          return { ...passage, imageUrl };
        }
        return passage;
      }));
      
      // Atualizar estados
      setPassages(prev => [...prev, ...passagesWithImages]);
      setFilteredPassages(prev => [...prev, ...passagesWithImages]);
      
      // Atualizar paginação
      setPagination(prev => ({
        ...prev,
        page,
        hasMore,
        activeFilter: 'advanced'
      }));
      
    } catch (error) {
      console.error('Erro ao carregar mais passagens:', error);
      toast({
        title: "Erro ao carregar mais passagens",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingMore(false);
    }
  };

  // Componente de select customizado para câmeras com busca
  const CameraSearchSelect = ({ cameras, value, onChange, placeholder = "Selecione uma câmera" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredCameras, setFilteredCameras] = useState(cameras);
    const ref = useRef();

    // Fechar quando clicar fora
    useOutsideClick({
      ref: ref,
      handler: () => setIsOpen(false),
    });

    // Filtrar câmeras baseado na busca
    useEffect(() => {
      if (!searchTerm) {
        setFilteredCameras(cameras);
      } else {
        const filtered = cameras.filter(camera =>
          camera.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          camera.id.toString().includes(searchTerm)
        );
        setFilteredCameras(filtered);
      }
    }, [searchTerm, cameras]);

    // Obter nome da câmera selecionada
    const getSelectedCameraName = () => {
      if (!value) return "";
      const camera = cameras.find(cam => cam.id.toString() === value.toString());
      return camera ? camera.name : "";
    };

    // Limpar seleção
    const clearSelection = () => {
      onChange({ target: { name: "cameraId", value: "" } });
      setSearchTerm("");
      setIsOpen(false);
    };

    return (
      <Box position="relative" ref={ref}>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <ChakraSearchIcon color="gray.400" />
          </InputLeftElement>
          <Input
            placeholder={value ? getSelectedCameraName() : placeholder}
            value={isOpen ? searchTerm : (value ? getSelectedCameraName() : "")}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsOpen(true)}
            cursor="pointer"
            readOnly={!isOpen}
          />
          {value && (
            <Button
              position="absolute"
              right="8px"
              top="50%"
              transform="translateY(-50%)"
              size="xs"
              variant="ghost"
              onClick={clearSelection}
              zIndex={2}
              color="gray.400"
              _hover={{ color: "gray.600" }}
            >
              ✕
            </Button>
          )}
        </InputGroup>

        {isOpen && (
          <Box
            position="absolute"
            top="100%"
            left={0}
            right={0}
            zIndex={1000}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            boxShadow="lg"
            maxH="200px"
            overflowY="auto"
            mt={1}
          >
            <List spacing={0}>
              {filteredCameras.length === 0 ? (
                <ListItem p={3} color="gray.500" textAlign="center">
                  Nenhuma câmera encontrada
                </ListItem>
              ) : (
                filteredCameras.map((camera) => (
                  <ListItem
                    key={camera.id}
                    p={3}
                    cursor="pointer"
                    _hover={{ bg: "gray.100" }}
                    borderBottom="1px solid"
                    borderBottomColor="gray.100"
                    onClick={() => {
                      onChange({ target: { name: "cameraId", value: camera.id.toString() } });
                      setIsOpen(false);
                      setSearchTerm("");
                    }}
                  >
                    <Text fontWeight="medium">{camera.name}</Text>
                    <Text fontSize="sm" color="gray.500">ID: {camera.id}</Text>
                  </ListItem>
                ))
              )}
            </List>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.100">
      <Flex justify="space-between" align="center" mb={4}>
        <Heading display="flex" alignItems="center">
          <CarIcon />
          Passagens de Veículos
        </Heading>
        <HStack>
          <Button 
            colorScheme="green" 
            onClick={refreshPassages} 
            leftIcon={<RefreshIcon />}
            isLoading={loading && pagination.page === 1}
            loadingText="Atualizando"
          >
            Atualizar
          </Button>
          <Button 
            colorScheme="blue" 
            onClick={() => fetchLast24Hours(false)} 
            leftIcon={<SearchIcon />}
          >
            Últimas 24h
          </Button>
          <Button 
            colorScheme="teal" 
            onClick={onOpen} 
            leftIcon={<FilterIcon />}
          >
            Filtros Avançados
          </Button>
        </HStack>
      </Flex>      {/* Tabs para estatísticas, lista e placas monitoradas */}
      <Tabs variant="soft-rounded" colorScheme="green" mb={4}>
        <TabList>
          <Tab>Estatísticas</Tab>
          <Tab>Lista de Passagens</Tab>
          {userLevel >= 3 && <Tab>Placas Monitoradas</Tab>}
        </TabList>
          <TabPanels>
          {/* TabPanel para Estatísticas */}
          <TabPanel>
            {loadingStats ? (
              <Flex justify="center" my={8}>
                <Spinner size="xl" />
              </Flex>
            ) : (
              <Box>
                {/* Estatísticas de passagens */}
                <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={6}>
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Passagens (24h)</StatLabel>
                    <StatNumber>{statistics.totalLast24Hours}</StatNumber>
                    <StatHelpText>Últimas 24 horas</StatHelpText>
                  </Stat>
                  
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Passagens (7 dias)</StatLabel>
                    <StatNumber>{statistics.totalLast7Days}</StatNumber>
                    <StatHelpText>Última semana</StatHelpText>
                  </Stat>
                  
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Passagens (30 dias)</StatLabel>
                    <StatNumber>{statistics.totalLast30Days}</StatNumber>
                    <StatHelpText>Último mês</StatHelpText>
                  </Stat>
                </SimpleGrid>
                
                <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={6}>
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Alertas de Placas (24h)</StatLabel>
                    <StatNumber>{statistics.alertsLast24Hours}</StatNumber>
                    <StatHelpText>Placas monitoradas</StatHelpText>
                  </Stat>
                  
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Confiança Média</StatLabel>
                    <StatNumber>
                      {(statistics.avgConfidence * 100).toFixed(1)}%
                    </StatNumber>
                    <StatHelpText>Na leitura de placas</StatHelpText>
                  </Stat>
                  
                  <Stat bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <StatLabel>Taxa de Detecção</StatLabel>
                    <StatNumber>
                      {statistics.totalLast24Hours > 0 ? 
                        (statistics.totalLast24Hours / 24).toFixed(1) : '0'}/h
                    </StatNumber>
                    <StatHelpText>Passagens por hora</StatHelpText>
                  </Stat>
                </SimpleGrid>
                
                {/* Top Câmeras e Top Placas */}
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={6}>
                  <Box bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <Heading size="md" mb={4}>Top 5 Câmeras (7 dias)</Heading>
                    {statistics.topCameras.map((camera, index) => (
                      <HStack key={camera.cameraId} mb={2} justify="space-between">
                        <Text>{index + 1}. {camera.cameraName}</Text>
                        <Badge colorScheme="blue">{camera.count} passagens</Badge>
                      </HStack>
                    ))}
                  </Box>
                  
                  <Box bg="white" p={4} borderRadius="lg" boxShadow="md">
                    <Heading size="md" mb={4}>Top 5 Placas (7 dias)</Heading>
                    {statistics.topPlates.map((plate, index) => (
                      <HStack key={plate.plateNumber} mb={2} justify="space-between">
                        <Text>{index + 1}. {plate.plateNumber}</Text>
                        <Badge colorScheme="green">{plate.count} passagens</Badge>
                      </HStack>
                    ))}
                  </Box>
                </SimpleGrid>
                
                {/* Distribuição por Hora do Dia */}
                <Box bg="white" p={4} borderRadius="lg" boxShadow="md">
                  <HourlyDistribution data={statistics.hourlyDistribution} />
                </Box>
              </Box>
            )}
          </TabPanel>
          
          <TabPanel>
            {/* Lista de Passagens (existente) */}
            {loading ? (
              <Flex justify="center" my={12}>
                <Spinner size="xl" />
              </Flex>
            ) : filteredPassages.length === 0 ? (
              <Flex direction="column" align="center" justify="center" py={12} bg="white" borderRadius="md" boxShadow="sm">
                <Text fontSize="xl" mb={4}>Nenhuma passagem encontrada</Text>
                <Button colorScheme="teal" onClick={resetFilters}>Limpar Filtros</Button>
              </Flex>
            ) : (
              <Box>
                <Grid templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap={6} mb={6}>
                  {filteredPassages.map((passage) => (
                    <GridItem key={passage.id} w="100%" bg="white" boxShadow="md" borderRadius="md" overflow="hidden">
                      <Box position="relative">
                        {passage.imageUrl ? (
                          <Image
                            src={passage.imageUrl}
                            alt={`Placa ${passage.plateNumber}`}
                            w="100%"
                            h="200px"
                            objectFit="cover"
                            onClick={() => openImageModal(passage.imageUrl)}
                            cursor="pointer"
                          />
                        ) : (
                          <Flex
                            w="100%"
                            h="200px"
                            bg="gray.200"
                            justify="center"
                            align="center"
                          >
                            <Text color="gray.500">Sem imagem</Text>
                          </Flex>
                        )}
                        
                        {passage.isAlert && (
                          <Badge
                            position="absolute"
                            top="10px"
                            right="10px"
                            colorScheme={getAlertBadgeColor(passage)}
                            px={2}
                            py={1}
                            borderRadius="md"
                          >
                            {getAlertBadgeText(passage)}
                          </Badge>
                        )}
                      </Box>
                      
                      <Box p={4}>
                        <Flex justify="space-between" mb={2}>
                          <Badge 
                            colorScheme={passage.confidence > 0.9 ? "green" : passage.confidence > 0.7 ? "yellow" : "orange"}
                            px={2}
                            py={1}
                            borderRadius="md"
                          >
                            Confiança: {(passage.confidence * 100).toFixed(1)}%
                          </Badge>
                          <Text fontWeight="bold" fontSize="lg">
                            {passage.plateNumber}
                          </Text>
                        </Flex>
                        
                        <HStack mt={2}>
                          <CameraIcon />
                          <Text color="gray.600" fontSize="sm">
                            {getCameraName(passage.cameraId)}
                          </Text>
                        </HStack>
                        
                        <Text color="gray.600" fontSize="sm" mt={1}>
                          {formatDate(passage.detectedAt)}
                        </Text>
                      </Box>
                    </GridItem>
                  ))}
                </Grid>
                
                {/* Botão "Ver Mais" */}
                {pagination.hasMore && (
                  <Flex justify="center" mt={4} mb={6}>
                    <Button 
                      onClick={loadMorePassages}
                      isLoading={loadingMore}
                      loadingText="Carregando..."
                      colorScheme="blue"
                      size="lg"
                      width="200px"
                    >
                      Ver Mais
                    </Button>
                  </Flex>
                )}
              </Box>
            )}
          </TabPanel>
          
          <TabPanel>
            <Box>
              <Flex justify="space-between" align="center" mb={5}>
                <Heading size="lg">Gerenciamento de Placas Monitoradas</Heading>
                <Button colorScheme="teal" onClick={onPlateModalOpen}>
                  Adicionar Placa
                </Button>
              </Flex>
              
              {loadingPlates ? (
                <Flex justify="center" my={10}>
                  <Spinner size="xl" />
                </Flex>
              ) : (
                <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap={6}>
                  {/* Lista de placas monitoradas */}
                  <Box bg="white" p={4} borderRadius="lg" boxShadow="md" height="fit-content">
                    <Heading size="md" mb={4}>Placas Monitoradas</Heading>
                    
                    {monitoredPlates.length === 0 ? (
                      <Text py={4} textAlign="center">
                        Nenhuma placa monitorada cadastrada
                      </Text>
                    ) : (
                      <Box maxH="600px" overflowY="auto">
                        {monitoredPlates.map(plate => (
                          <Box 
                            key={plate.id} 
                            p={3} 
                            mb={3} 
                            borderWidth="1px" 
                            borderRadius="md"
                            bg={selectedPlate?.id === plate.id ? "teal.50" : "white"}
                            _hover={{ bg: "gray.50" }}
                            cursor="pointer"
                            onClick={() => handleSelectPlate(plate)}
                          >
                            <Flex justify="space-between" align="start" mb={2}>
                              <Box flex="1">
                                <Flex align="center" gap={2} mb={1}>
                                  <Heading size="sm">{plate.plateNumber}</Heading>
                                  <Badge 
                                    colorScheme={plate.isBlacklist ? "red" : "orange"}
                                  >
                                    {plate.isBlacklist ? "Blacklist" : "Monitorada"}
                                  </Badge>
                                  <Badge 
                                    colorScheme={
                                      plate.alertPriority === 'critical' ? 'red' :
                                      plate.alertPriority === 'high' ? 'orange' :
                                      plate.alertPriority === 'medium' ? 'yellow' : 'gray'
                                    }
                                  >
                                    {plate.alertPriority === 'low' ? 'Prioridade Baixa' :
                                     plate.alertPriority === 'medium' ? 'Prioridade Média' :
                                     plate.alertPriority === 'high' ? 'Prioridade Alta' :
                                     'Prioridade Crítica'}
                                  </Badge>
                                  {(Array.isArray(plate.interestedUserIds) && plate.interestedUserIds.length > 0) ? (
                                    plate.interestedUserIds.map(uid => (
                                      <Badge key={uid} colorScheme="blue" ml={1}>
                                        {(users.find(u => u.id === uid) || {}).username || `Usuário ${uid}`}
                                      </Badge>
                                    ))
                                  ) : (
                                    plate.interestedUserId && users.length > 0 && (
                                      <Badge colorScheme="blue">
                                        Interessado: { (users.find(u => u.id === parseInt(plate.interestedUserId, 10)) || {}).username || 'Usuário' }
                                      </Badge>
                                    )
                                  )}
                                </Flex>
                                <Text fontSize="sm" color="gray.600" mb={1}>
                                  {plate.description || "Sem descrição"}
                                </Text>
                                {plate.vehicleType && (
                                  <Text fontSize="xs" color="gray.500">
                                    Tipo: {plate.vehicleType}
                                  </Text>
                                )}
                                {plate.notes && (
                                  <Text fontSize="xs" color="blue.600" mt={1} fontStyle="italic">
                                    📝 {plate.notes}
                                  </Text>
                                )}
                                <Flex align="center" gap={2} mt={2}>
                                  <Badge 
                                    colorScheme={plate.notificationEnabled ? "green" : "gray"}
                                    fontSize="xs"
                                  >
                                    {plate.notificationEnabled ? "🔔 Notificações ON" : "🔕 Notificações OFF"}
                                  </Badge>
                                  {plate.detectionCount > 0 && (
                                    <Badge colorScheme="blue" fontSize="xs">
                                      {plate.detectionCount} detecções
                                    </Badge>
                                  )}
                                </Flex>
                              </Box>
                            </Flex>
                            <Flex justify="flex-end" gap={1}>
                              <Button
                                size="xs"
                                colorScheme="blue"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenEditPlate(plate);
                                }}
                              >
                                Editar
                              </Button>
                              <Button
                                size="xs"
                                colorScheme={plate.isBlacklist ? "gray" : "red"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggleBlacklist(plate);
                                }}
                              >
                                {plate.isBlacklist ? "Remover Blacklist" : "Add Blacklist"}
                              </Button>
                              <Button
                                size="xs"
                                colorScheme="red"
                                variant="outline"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemovePlate(plate.id);
                                }}
                              >
                                Excluir
                              </Button>
                            </Flex>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                  
                  {/* Visualização de passagens da placa selecionada */}
                  <Box bg="white" p={4} borderRadius="lg" boxShadow="md">
                    {selectedPlate ? (
                      <>
                        <Heading size="md" mb={4}>
                          Passagens da Placa: {selectedPlate.plateNumber}
                          <Badge 
                            ml={2} 
                            colorScheme={selectedPlate.isBlacklist ? "red" : "orange"}
                          >
                            {selectedPlate.isBlacklist ? "Blacklist" : "Monitorada"}
                          </Badge>
                        </Heading>
                        
                        {loadingPlatePassages ? (
                          <Flex justify="center" my={10}>
                            <Spinner size="xl" />
                          </Flex>
                        ) : platePassages.length === 0 ? (
                          <Text py={4} textAlign="center">
                            Nenhuma passagem registrada para esta placa
                          </Text>
                        ) : (
                          <Box maxH="600px" overflowY="auto">
                            <Grid templateColumns="repeat(auto-fill, minmax(200px, 1fr))" gap={4}>
                              {platePassages.map((passage) => (
                                <Box 
                                  key={passage.id} 
                                  borderWidth="1px" 
                                  borderRadius="md" 
                                  overflow="hidden"
                                >
                                  {passage.imageUrl ? (
                                    <Image
                                      src={passage.imageUrl}
                                      alt={`Placa ${passage.plateNumber}`}
                                      w="100%"
                                      h="120px"
                                      objectFit="cover"
                                      onClick={() => openImageModal(passage.imageUrl)}
                                      cursor="pointer"
                                    />
                                  ) : (
                                    <Flex
                                      w="100%"
                                      h="120px"
                                      bg="gray.200"
                                      justify="center"
                                      align="center"
                                    >
                                      <Text color="gray.500" fontSize="sm">Sem imagem</Text>
                                    </Flex>
                                  )}
                                  
                                  <Box p={2}>
                                    <Text fontSize="sm" fontWeight="bold">
                                      {getCameraName(passage.cameraId)}
                                    </Text>
                                    <Text fontSize="xs" color="gray.600">
                                      {formatDate(passage.detectedAt)}
                                    </Text>
                                  </Box>
                                </Box>
                              ))}
                            </Grid>
                          </Box>
                        )}
                      </>
                    ) : (
                      <Flex 
                        direction="column" 
                        justify="center" 
                        align="center" 
                        height="100%"
                        minH="300px"
                      >
                        <Text color="gray.500">
                          Selecione uma placa para visualizar suas passagens
                        </Text>
                      </Flex>
                    )}
                  </Box>
                </Grid>
              )}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* Modal para imagem (existente) */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Imagem da Passagem</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image 
              src={selectedImage} 
              alt="Imagem da passagem" 
              objectFit="contain"
              width="100%"
              height="100%"
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => setIsModalOpen(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Drawer de Filtros - atualizado com busca de câmera */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Filtrar Passagens</DrawerHeader>

          <DrawerBody>
            <Box py={4}>
              <FormControl mb={4}>
                <FormLabel>Placa</FormLabel>
                <Input
                  name="plate"
                  placeholder="AAA0000"
                  value={filters.plate}
                  onChange={handleFilterChange}
                />
                <HStack mt={2} spacing={2}>
                  <Switch
                    name="plateContains"
                    isChecked={filters.plateContains || false}
                    onChange={(e) => setFilters(prev => ({
                      ...prev,
                      plateContains: e.target.checked
                    }))}
                  />
                  <Text fontSize="sm" color="gray.600">
                    Buscar placas que <strong>contenham</strong> o texto
                  </Text>
                </HStack>
                <Text fontSize="xs" color="gray.500" mt={1}>
                  {filters.plateContains 
                    ? "Ex: 'PIA' encontrará PIA0000, PIA0001, PIA1958..." 
                    : "Ex: 'PIA0000' encontrará apenas PIA0000 exato"
                  }
                </Text>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>Câmera</FormLabel>
                <CameraSearchSelect
                  cameras={cameras}
                  value={filters.cameraId}
                  onChange={handleFilterChange}
                  placeholder="Buscar câmera por nome..."
                />
              </FormControl>

              <Divider my={6} />

              <FormControl mb={4}>
                <FormLabel>Data Inicial</FormLabel>
                <HStack>
                  <Input
                    type="date"
                    name="startDate"
                    value={filters.startDate}
                    onChange={handleFilterChange}
                    flex="1"
                  />
                  <Input
                    type="time"
                    name="startTime"
                    value={filters.startTime || ""}
                    onChange={handleFilterChange}
                    maxW="140px"
                  />
                </HStack>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>Data Final</FormLabel>
                <HStack>
                  <Input
                    type="date"
                    name="endDate"
                    value={filters.endDate}
                    onChange={handleFilterChange}
                    flex="1"
                  />
                  <Input
                    type="time"
                    name="endTime"
                    value={filters.endTime || ""}
                    onChange={handleFilterChange}
                    maxW="140px"
                  />
                </HStack>
              </FormControl>

              <Button
                mt={4}
                colorScheme="teal"
                onClick={applyAdvancedFilters}
                width="full"
              >
                Filtrar
              </Button>

              <Button
                mt={4}
                variant="outline"
                onClick={resetFilters}
                width="full"
              >
                Limpar Filtros
              </Button>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      {/* Modal para adicionar placa */}
      <Modal isOpen={isPlateModalOpen} onClose={onPlateModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Adicionar Nova Placa Monitorada</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired mb={4}>
              <FormLabel>Número da Placa</FormLabel>
              <Input 
                name="plateNumber"
                placeholder="AAA0000" 
                value={plateFormData.plateNumber}
                onChange={handlePlateFormChange}
              />
            </FormControl>
            
            <FormControl mb={4}>
              <FormLabel>Descrição</FormLabel>
              <Input 
                name="description"
                placeholder="Descreva o motivo do monitoramento" 
                value={plateFormData.description}
                onChange={handlePlateFormChange}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Tipo de Veículo (opcional)</FormLabel>
              <Input
                name="vehicleType"
                placeholder="Ex: Táxi, Ônibus, Motorista Aplicativo"
                value={plateFormData.vehicleType}
                onChange={handlePlateFormChange}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Interessados (usuários que receberão notificações)</FormLabel>
              <HStack mb={2}>
                <Box flex="1">
                  <UserSearchSelect
                    users={users}
                    value={selectedInterestedToAdd}
                    onChange={(e) => setSelectedInterestedToAdd(e.target.value)}
                    placeholder="Escolha um usuário..."
                  />
                </Box>
                <Button
                  onClick={() => {
                    if (!selectedInterestedToAdd) return;
                    const id = parseInt(selectedInterestedToAdd, 10);
                    if (Number.isNaN(id)) return;
                    setPlateFormData(prev => {
                      const arr = Array.isArray(prev.interestedUserIds) ? [...prev.interestedUserIds] : [];
                      if (!arr.includes(id)) arr.push(id);
                      return { ...prev, interestedUserIds: arr };
                    });
                    setSelectedInterestedToAdd('');
                  }}
                >
                  Adicionar
                </Button>
              </HStack>

              <HStack spacing={2} wrap="wrap">
                {(plateFormData.interestedUserIds || []).map(uid => {
                  const u = users.find(x => x.id === uid) || { username: `Usuário ${uid}` };
                  return (
                    <Badge key={uid} colorScheme="blue" px={2} py={1} borderRadius="md">
                      {u.username}
                      <Button size="xs" ml={2} variant="ghost" onClick={() => setPlateFormData(prev => ({ ...prev, interestedUserIds: prev.interestedUserIds.filter(i => i !== uid) }))}>
                        ✕
                      </Button>
                    </Badge>
                  );
                })}
              </HStack>

              <Text fontSize="xs" color="gray.500" mt={2}>
                (Opcional) Usuários que serão notificados diretamente sobre esta placa.
              </Text>
            </FormControl>
            
            <FormControl mb={4}>
              <FormLabel>Prioridade do Alerta</FormLabel>
              <Select
                name="alertPriority"
                value={plateFormData.alertPriority}
                onChange={handlePlateFormChange}
              >
                <option value="low">Baixa</option>
                <option value="medium">Média</option>
                <option value="high">Alta</option>
                <option value="critical">Crítica</option>
              </Select>
            </FormControl>
            
            <FormControl display="flex" alignItems="center" mb={4}>
              <FormLabel htmlFor="isBlacklist" mb="0">
                Adicionar à Blacklist?
              </FormLabel>
              <Switch 
                id="isBlacklist" 
                name="isBlacklist"
                colorScheme="red" 
                isChecked={plateFormData.isBlacklist}
                onChange={handlePlateFormChange}
              />
            </FormControl>
            
            <FormControl display="flex" alignItems="center" mb={4}>
              <FormLabel htmlFor="notificationEnabled" mb="0">
                Ativar Notificações?
              </FormLabel>
              <Switch 
                id="notificationEnabled" 
                name="notificationEnabled"
                colorScheme="teal" 
                isChecked={plateFormData.notificationEnabled}
                onChange={handlePlateFormChange}
              />
            </FormControl>
            
            <FormControl mb={4}>
              <FormLabel>Notas Adicionais (opcional)</FormLabel>
              <Input
                name="notes"
                placeholder="Informações extras sobre esta placa"
                value={plateFormData.notes}
                onChange={handlePlateFormChange}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="gray" mr={3} onClick={onPlateModalClose}>
              Cancelar
            </Button>
            <Button colorScheme="teal" onClick={handleAddPlate}>
              Adicionar Placa
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal para editar placa */}
      <Modal isOpen={isEditPlateModalOpen} onClose={onEditPlateModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar Placa Monitorada</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editingPlate && (
              <>
                <FormControl mb={4}>
                  <FormLabel>Número da Placa</FormLabel>
                  <Input 
                    value={editingPlate.plateNumber}
                    isReadOnly
                    bg="gray.100"
                  />
                </FormControl>
                
                <FormControl mb={4}>
                  <FormLabel>Descrição</FormLabel>
                  <Input 
                    placeholder="Descreva o motivo do monitoramento" 
                    value={editingPlate.description || ''}
                    onChange={(e) => setEditingPlate({...editingPlate, description: e.target.value})}
                  />
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>Tipo de Veículo (opcional)</FormLabel>
                  <Input
                    placeholder="Ex: Táxi, Ônibus, Motorista Aplicativo"
                    value={editingPlate.vehicleType || ''}
                    onChange={(e) => setEditingPlate({...editingPlate, vehicleType: e.target.value})}
                  />
                </FormControl>
                
                <FormControl mb={4}>
                  <FormLabel>Prioridade do Alerta</FormLabel>
                  <Select
                    value={editingPlate.alertPriority}
                    onChange={(e) => setEditingPlate({...editingPlate, alertPriority: e.target.value})}
                  >
                    <option value="low">Baixa</option>
                    <option value="medium">Média</option>
                    <option value="high">Alta</option>
                    <option value="critical">Crítica</option>
                  </Select>
                </FormControl>
                
                <FormControl display="flex" alignItems="center" mb={4}>
                  <FormLabel htmlFor="edit-isBlacklist" mb="0">
                    Adicionar à Blacklist?
                  </FormLabel>
                  <Switch 
                    id="edit-isBlacklist" 
                    colorScheme="red" 
                    isChecked={editingPlate.isBlacklist}
                    onChange={(e) => setEditingPlate({...editingPlate, isBlacklist: e.target.checked})}
                  />
                </FormControl>
                
                <FormControl display="flex" alignItems="center" mb={4}>
                  <FormLabel htmlFor="edit-notificationEnabled" mb="0">
                    Ativar Notificações?
                  </FormLabel>
                  <Switch 
                    id="edit-notificationEnabled" 
                    colorScheme="teal" 
                    isChecked={editingPlate.notificationEnabled}
                    onChange={(e) => setEditingPlate({...editingPlate, notificationEnabled: e.target.checked})}
                  />
                </FormControl>
                
                <FormControl mb={4}>
                  <FormLabel>Notas Adicionais (opcional)</FormLabel>
                  <Input
                    placeholder="Informações extras sobre esta placa"
                    value={editingPlate.notes || ''}
                    onChange={(e) => setEditingPlate({...editingPlate, notes: e.target.value})}
                  />
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>Interessados (usuários que receberão notificações)</FormLabel>
                  <HStack mb={2}>
                    <Box flex="1">
                      <UserSearchSelect
                        users={users}
                        value={selectedInterestedToEdit}
                        onChange={(e) => setSelectedInterestedToEdit(e.target.value)}
                        placeholder="Escolha um usuário..."
                      />
                    </Box>
                    <Button
                      onClick={() => {
                        if (!selectedInterestedToEdit) return;
                        const id = parseInt(selectedInterestedToEdit, 10);
                        if (Number.isNaN(id)) return;
                        setEditingPlate(prev => {
                          const arr = Array.isArray(prev.interestedUserIds) ? [...prev.interestedUserIds] : [];
                          if (!arr.includes(id)) arr.push(id);
                          return { ...prev, interestedUserIds: arr };
                        });
                        setSelectedInterestedToEdit('');
                      }}
                    >
                      Adicionar
                    </Button>
                  </HStack>

                  <HStack spacing={2} wrap="wrap">
                    {(editingPlate.interestedUserIds || []).map(uid => {
                      const u = users.find(x => x.id === uid) || { username: `Usuário ${uid}` };
                      return (
                        <Badge key={uid} colorScheme="blue" px={2} py={1} borderRadius="md">
                          {u.username}
                          <Button size="xs" ml={2} variant="ghost" onClick={() => setEditingPlate(prev => ({ ...prev, interestedUserIds: prev.interestedUserIds.filter(i => i !== uid) }))}>
                            ✕
                          </Button>
                        </Badge>
                      );
                    })}
                  </HStack>

                  <Text fontSize="xs" color="gray.500" mt={2}>
                    (Opcional) Usuários que serão notificados diretamente sobre esta placa.
                  </Text>
                </FormControl>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="gray" mr={3} onClick={onEditPlateModalClose}>
              Cancelar
            </Button>
            <Button colorScheme="teal" onClick={handleUpdatePlate}>
              Salvar Alterações
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default VehiclePassages;